import { z } from 'zod';
import { CustomVizRequest } from 'libs/end-to-end/src/custom-viz/CustomVizRequest';

export const SavedAnalysisOutputSchema = z.object({
  organizationId: z.string(),
  databaseId: z.string(),
  customVizRequest: CustomVizRequest,
  shareLink: z.string(),
  savedAnalysisId: z.string(),
});

export type SavedAnalysisOutputSchema = z.infer<
  typeof SavedAnalysisOutputSchema
>;

export const SavedAnalysesListSchema = z.object({
  savedAnalysesList: SavedAnalysisOutputSchema.array(),
});

export type SavedAnalysesListSchema = z.infer<typeof SavedAnalysesListSchema>;
